
define('text!templates/modules/setting/business/list/invoice-history-list-item.html',[],function () { return '<td><span class="button-download-invoice"></span></td>\n<td>{{date}}</td>\n<td>{{total}}</td>\n';});

